import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../components/Layout';
import { useAuth } from '../../context/AuthContext';
import { filterMenuItems } from '../../utils/menuAccess';
import './SecuritePage.css';

const securiteItems = [
  { label: 'Limite d\'Exposition', icon: '🛡️', path: '/controles/exposition' },
  { label: 'Ratio Konbinezon', icon: '⚖️', path: '/securite/konbinezon-ratio' },
  { label: 'Validation Konbinezon', icon: '🔗', path: '/securite/konbinezon-validation' },
  { label: 'Pousantaj sou Borlet', icon: '🎯', path: '/securite/borlette-coverage' },
  { label: 'Pousantaj sou Maryaj', icon: '💍', path: '/securite/maryaj-ratio' },
  { label: 'Nombre de boules par fiche', icon: '🔢', path: '/securite/max-boules' },
  { label: "Journal d'audit", icon: '📋', path: '/securite/audit-log' },
];

const SecuritePage = () => {
  const { company } = useAuth();
  const visibleItems = useMemo(
    () => filterMenuItems(securiteItems, company?.menu_keys),
    [company?.menu_keys],
  );

  return (
    <Layout>
      <p className="sec-breadcrumb">
        Ruta : <Link to="/dashboard" className="bc-link">Menu</Link>
        {' >> '}
        <Link to="/securite" className="bc-link">Securite</Link>
      </p>

      <div className="sec-grid">
        {visibleItems.map((item) => (item.path ? (
          <Link key={item.label} to={item.path} className="sec-item">
            <div className="sec-icon">{item.icon}</div>
            <span className="sec-label">{item.label}</span>
          </Link>
        ) : (
          <div key={item.label} className="sec-item">
            <div className="sec-icon">{item.icon}</div>
            <span className="sec-label sec-label-disabled">{item.label}</span>
          </div>
        )))}
      </div>
    </Layout>
  );
};

export default SecuritePage;
